import React from "react";
import "./card.css";
import { motion } from "framer-motion";

const Card = ({
  imgURL,
  title,
  subText,
  techStack,
  imglink,
  live,
  gitlink,
  github,
}) => {
  return (
    <motion.div
      className="app__card"
      whileHover={{
        scale: 1.1,
        boxShadow: "2px 2px 100px 0px rgba(0, 0, 0, 0.20)",
      }}
      transition={{
        type: "spring",
        stiffness: 100,
        damping: 10,
      }}
    >
      <div className="app__card-img">
        <img src={imgURL} alt="Card img" />
      </div>
      <div className="app__card-content">
        <h1 className="card__h1">{title}</h1>
        <p className="card__p">{subText}</p>
        <p className="card__p-tech">{techStack}</p>
      </div>
      <div className="card__link-chain">
        <img src={imglink} alt="link icon" />
        <p className="card__link"> {live} </p>

        <img src={gitlink} alt="git icon" />
        <p className="card__link"> {github} </p>
      </div>
    </motion.div>
  );
};

export default Card;
